/** Política do auth-api para senhas novas (convite, reposição e troca). */
export const MIN_PASSWORD_LENGTH = 8;
/** Limite do bcrypt no backend: 72 bytes, não caracteres. */
export const MAX_PASSWORD_BYTES = 72;

export type PasswordPolicyError = "tooShort" | "tooLong" | "mismatch";

export function newPasswordError(password: string, confirmation: string): PasswordPolicyError | null {
    if (password.length < MIN_PASSWORD_LENGTH) return "tooShort";
    if (new TextEncoder().encode(password).length > MAX_PASSWORD_BYTES) return "tooLong";
    if (password !== confirmation) return "mismatch";
    return null;
}
